import { render } from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=template&id=673c7f42&scoped=true"
import script from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveFewOnboardComponent.vue?vue&type=style&index=0&id=673c7f42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673c7f42"]])

export default __exports__